import React, { Dispatch, SetStateAction } from "react";
import { QuickActions } from "./quick/QuickActions";
import { toKey } from "../../components/editModalFunctions";
import ProductTypeCreateInline from "../../components/ProductTypeCreateInline";
import { resolveProductTypeSelection } from "../../lib/productTypeSelection";
type FormState = any;


type AiSuggestions = {
  manufacturer?: string | null;
  model?: string | null;
  productType?: string | null;
  loading?: boolean;
  error?: string | null;
};

type Props = {
  form: FormState;
  setForm: Dispatch<SetStateAction<FormState>>;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
  customerListOpts: Array<{ key: string; name: string }>;
  showNewCustomerInput: boolean;
  setShowNewCustomerInput: (v: boolean) => void;
  newCustomer: string;
  setNewCustomer: (v: string) => void;
  handleNewCustomerAdd: () => void;
  aiSuggestions: AiSuggestions;
  requestSuggestions: (args: {
    serial: string;
    manufacturer?: string;
    productTypes: string[];
    manufacturerList: string[];
    modelList: string[];
    rpTypeOpts: any[];
    setForm: Dispatch<SetStateAction<FormState>>;
  }) => Promise<void>;
  rpTypeOpts: any[];
  manufacturerList: string[];
  modelList: string[];
  setShowNewManufacturerInput: (v: boolean) => void;
  showNewManufacturerInput: boolean;
  newManufacturer: string;
  setNewManufacturer: (v: string) => void;
  manufacturerExists: boolean;
  handleNewManufacturerAdd: () => void;
  setShowNewModelInput: (v: boolean) => void;
  showNewModelInput: boolean;
  newModel: string;
  setNewModel: (v: string) => void;
  userEditedModelRef: React.MutableRefObject<boolean>;
  modelExistsForThisManufacturer: boolean;
  handleNewModelAdd: () => void;
  setShowNewProductTypeInput: (v: boolean) => void;
  showNewProductTypeInput: boolean;
  newProductType: string;
  setNewProductType: (v: string) => void;
  productTypeExists: boolean;
  ensureProductTypeInDb: (name: string) => Promise<any>;
  setRpTypeOpts: (opts: any[]) => void;
  setRpTypesPrimed: (v: boolean) => void;
  articleList: string[];
  showNewArticleInput: boolean;
  setShowNewArticleInput: (v: boolean) => void;
  newArticle: string;
  setNewArticle: (v: string) => void;
  handleNewArticleAdd: () => void;
  normalizeSerialKey: (s: string) => string;
  splitSerialParts: (s: string) => { base: string; visit: number };
  openWarranty: (args: { manufacturer: string; serialBase: string; form: FormState; focusAfter?: boolean }) => void | Promise<void>;
  markNoWarranty: (focusAfter?: boolean) => void;
  handleIsoDateInput: (e: React.FormEvent<HTMLInputElement>) => void;
  parseLooseDateToISO: (v: string) => string | null;
  handlePhotoChange: (e: React.ChangeEvent<HTMLInputElement>, key: any) => void | Promise<void>;
  handleRemovePhoto: (key: any) => void;
  thumbnailPreviews: Record<string, string | null>;
  handleSave: () => void | Promise<void>;
  isSaving: boolean;
  quickOrderRef: any;
  formatSerialForDisplay: (s: string) => string;
  fmtDateOnly: (d: any) => string;
};

// 1:1-kopia av snabbinmatnings-blocket från App.tsx. Ej inkopplad ännu.
export function HomeQuickView(props: Props): JSX.Element {
  const {
    form,
    setForm,
    handleInputChange,
    customerListOpts,
    showNewCustomerInput,
    setShowNewCustomerInput,
    newCustomer,
    setNewCustomer,
    handleNewCustomerAdd,
    aiSuggestions,
    requestSuggestions,
    rpTypeOpts,
    manufacturerList,
    modelList,
    setShowNewManufacturerInput,
    showNewManufacturerInput,
    newManufacturer,
    setNewManufacturer,
    manufacturerExists,
    handleNewManufacturerAdd,
    setShowNewModelInput,
    showNewModelInput,
    newModel,
    setNewModel,
    modelExistsForThisManufacturer,
    handleNewModelAdd,
    userEditedModelRef,
    setShowNewProductTypeInput,
    showNewProductTypeInput,
    newProductType,
    setNewProductType,
    productTypeExists,
    ensureProductTypeInDb,
    setRpTypeOpts,
    setRpTypesPrimed,
    articleList,
    showNewArticleInput,
    setShowNewArticleInput,
    newArticle,
    setNewArticle,
    handleNewArticleAdd,
    normalizeSerialKey,
    splitSerialParts,
    openWarranty,
    markNoWarranty,
    handleIsoDateInput,
    parseLooseDateToISO,
    handlePhotoChange,
    handleRemovePhoto,
    thumbnailPreviews,
    handleSave,
    isSaving,
    quickOrderRef,
    formatSerialForDisplay,
    fmtDateOnly,
  } = props;

  type PhotoKey = any;

  return (
    <>
      <div className="gw-card">
        <h3 className="gw-h3">Snabbinmatning</h3>

        <div className="gw-form-grid gw-form-grid--quick">
          {/* Rad 1 – sex fält (1 kol vardera) */}
          <label className="gw-form-field gw-col-1">
            <div className="gw-form-label">Ordernummer</div>
            <input
              ref={quickOrderRef}
              name="orderNumber"
              type="text"
              placeholder="Ordernummer"
              value={form.orderNumber}
              onChange={handleInputChange}
              className="gw-input"
            />
          </label>

          {/* Kund – span 4 */}
          <label className="gw-form-field gw-col-1">
            <div className="gw-form-label">Kund</div>
            <div className="flex flex-wrap items-center gap-2">
              <select
                value={form.customerKey || ""}
                onChange={(e) => {
                  const v = e.target.value;
                  if (v === "new") {
                    setShowNewCustomerInput(true);
                    setForm((p: any) => ({ ...p, customer: "", customerKey: "" }));
                  } else {
                    setShowNewCustomerInput(false);
                    const opt = Array.isArray(customerListOpts)
                      ? customerListOpts.find((o: any) => o.key === v)
                      : undefined;
                    setForm((p: any) => ({
                      ...p,
                      customer: opt?.name ?? "",
                      customerKey: opt?.key ?? "",
                    }));
                  }
                }}
                className="gw-input w-full max-w-full"
              >
                <option value="">Kund</option>
                {customerListOpts.map((opt: any) => (
                  <option key={opt.key} value={opt.key}>
                    {opt.name}
                  </option>
                ))}
                <option value="new">Lägg till ny kund</option>
              </select>

              {showNewCustomerInput && (
                <>
                  <input
                    type="text"
                    placeholder="Ny kund"
                    value={newCustomer}
                    onChange={(e) => setNewCustomer(e.target.value)}
                    className="gw-input"
                  />
                  <button type="button" onClick={handleNewCustomerAdd} className="gw-btn gw-btn-secondary">Lägg till</button>
                </>
              )}
            </div>
          </label>

            <label className="gw-form-field gw-col-1">
              <div className="gw-form-label">Serienummer</div>

              <div className="gw-input-wrap">
                <input
                  name="serial"
                  type="text"
                  placeholder="Serienummer"
                  value={form.serial ?? ""}
                  onChange={handleInputChange}
                  className="gw-input flex-1 pr-10"
                />

                {(() => {
                  const raw = String(form.serial || "");
                  const serialLen = raw.replace(/[\s-]/g, "").length;
                  if (serialLen < 6) return null;

                  return (
                    <button
                      type="button"
                      className="ai-inline"
                      tabIndex={0}
                      onMouseDown={(e) => e.preventDefault()}
                      onClick={async (e) => {
                        e.stopPropagation();
                        if (aiSuggestions.loading) return;
                        await requestSuggestions({
                          serial: raw,
                          manufacturer: form.manufacturer,
                          productTypes: (Array.isArray(rpTypeOpts) ? rpTypeOpts : []).map((t: any) => t.label),
                          manufacturerList: manufacturerList as any,
                          modelList: modelList as any,
                          rpTypeOpts: (Array.isArray(rpTypeOpts) ? rpTypeOpts : []) as any,
                          setForm,
                        });
                      }}
                      disabled={aiSuggestions.loading}
                      title={aiSuggestions.loading ? "Hämtar AI-förslag…" : "Hämta AI-förslag baserat på serienummer"}
                      aria-busy={aiSuggestions.loading}
                    >
                      <span className={`gw-ai-cube ${aiSuggestions.loading ? "gw-ai-pulse" : ""}`}>AI</span>
                    </button>
                  );
                })()}

              </div>

              {aiSuggestions.error && (
                <div className="mt-1 text-xs text-red-700">
                  {aiSuggestions.error}
                </div>
              )}
            </label>

            <label className="gw-form-field gw-col-1 relative">
              {aiSuggestions.manufacturer && (
                <div className="absolute right-1 -top-3.5 text-xs text-primary text-right">
                  Förslag
                </div>
              )}

              <div className="gw-form-label">Tillverkare</div>
              <div className="flex flex-wrap items-center gap-2">
                <select
                  value={form.manufacturer ?? ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "new") {
                      setShowNewManufacturerInput(true);
                      setForm((prev: any) => ({ ...prev, manufacturer: "" }));
                    } else {
                      setShowNewManufacturerInput(false);
                      setForm((prev: any) => ({ ...prev, manufacturer: value }));
                    }
                  }}
                  className="gw-input"
                >
                  <option value="">Tillverkare</option>
                  {(Array.isArray(manufacturerList) ? manufacturerList : []).map((man: any) => (
                    <option key={man} value={man}>{man}</option>
                  ))}

                  {aiSuggestions.manufacturer &&
                    !(Array.isArray(manufacturerList) ? manufacturerList : []).some(
                      (m: any) => toKey(m) === toKey(aiSuggestions.manufacturer!)
                    ) && (
                      <option key="ai-manufacturer" value={aiSuggestions.manufacturer!}>
                        {aiSuggestions.manufacturer} (AI-förslag)
                      </option>
                    )}

                  <option value="new">Lägg till ny tillverkare</option>
                </select>

                {showNewManufacturerInput && (
                  <>
                    <input
                      type="text"
                      placeholder="Ny tillverkare"
                      value={newManufacturer}
                      onChange={(e) => setNewManufacturer(e.target.value)}
                      className="gw-input"
                    />
                    {manufacturerExists && (
                      <div className="text-xs text-red-700">Tillverkaren finns redan.</div>
                    )}
                    <button
                      onClick={handleNewManufacturerAdd}
                      disabled={!newManufacturer.trim() || manufacturerExists}
                      title={manufacturerExists ? "Dublett: kan inte spara" : "Lägg till"}
                      className="gw-btn gw-btn-secondary"
                    >
                      Lägg till
                    </button>
                  </>
                )}
              </div>
            </label>

            <label className="gw-form-field gw-col-1 relative">
              {aiSuggestions.model && (
                <div className="absolute right-1 -top-3.5 text-xs text-primary text-right">
                  Förslag
                </div>
              )}

              <div className="gw-form-label">Modell</div>
              <div className="flex flex-wrap items-center gap-2">
                <select
                  value={form.model ?? ""}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (val === "new") {
                      setShowNewModelInput(true);
                      setForm((prev: any) => ({ ...prev, model: "" }));
                    } else {
                      setShowNewModelInput(false);
                      setForm((prev: any) => ({ ...prev, model: val }));
                    }
                  }}
                  className="gw-input"
                  disabled={!form.manufacturer}
                >
                  <option value="">{form.manufacturer ? "Modell" : "Välj tillverkare först"}</option>
                  {(Array.isArray(modelList) ? modelList : []).map((m: any) => (
                    <option key={m} value={m}>{m}</option>
                  ))}

                  {aiSuggestions.model &&
                    !(Array.isArray(modelList) ? modelList : []).some(
                      (m: any) => toKey(m) === toKey(aiSuggestions.model!)
                    ) && (
                      <option key="ai-model" value={aiSuggestions.model!}>
                        {aiSuggestions.model} (AI-förslag)
                      </option>
                    )}

                  {form.manufacturer && <option value="new">Lägg till ny modell</option>}
                </select>

                {showNewModelInput && (
                  <>
                    <input
                      type="text"
                      placeholder="Ny modell"
                      value={newModel}
                      onChange={(e) => { userEditedModelRef.current = true; setNewModel(e.target.value); }}
                      className="gw-input"
                    />
                    {modelExistsForThisManufacturer && (
                      <div className="text-xs text-red-700">
                        Modell finns redan för tillverkare.
                      </div>
                    )}
                    <button
                      onClick={handleNewModelAdd}
                      className="gw-btn gw-btn-secondary"
                      disabled={!newModel.trim() || modelExistsForThisManufacturer}
                      title={modelExistsForThisManufacturer ? "Dublett: kan inte spara" : "Lägg till"}
                    >
                      Lägg till
                    </button>
                  </>
                )}
              </div>
            </label>

          {/* Rad 3 */}

            {/* Rad 3 */}

            <label className="gw-form-field gw-col-1 relative">
              {aiSuggestions.productType && (
                <div className="absolute right-1 -top-3.5 text-xs text-primary text-right">
                  Förslag
                </div>
              )}

              <div className="gw-form-label">Produkttyp</div>
              <div className="flex flex-wrap items-center gap-2">
                <select
                  name="productType"
                  value={rpTypeOpts.some((t: any) => t.id === form.productTypeId)
                    ? form.productTypeId
                    : (form.productType || "")}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "new") {
                      setShowNewProductTypeInput(true);
                      setForm((prev: any) => ({ ...prev, productType: "", productTypeId: "" }));
                    } else {
                      setShowNewProductTypeInput(false);
                      setForm((prev: any) => ({
                        ...prev,
                        ...resolveProductTypeSelection(rpTypeOpts, value),
                      }));
                    }
                  }}
                  className="gw-input"
                >
                  <option value="">Välj kategori</option>
                  {(Array.isArray(rpTypeOpts) ? rpTypeOpts : []).map((t: any) => (
                    <option key={t.id} value={t.id}>{t.label}</option>
                  ))}

                  {aiSuggestions.productType &&
                    !(Array.isArray(rpTypeOpts) ? rpTypeOpts : []).some(
                      (t: any) => toKey(t.label) === toKey(aiSuggestions.productType!)
                    ) && (
                      <option key="ai-product-type" value={aiSuggestions.productType!}>
                        {aiSuggestions.productType} (AI-förslag)
                      </option>
                    )}

                <option value="new">Lägg till ny…</option>
              </select>

              {showNewProductTypeInput && (
                <div className="flex gap-1.5 mt-1.5">
                  <ProductTypeCreateInline
                    value={newProductType}
                    onChange={setNewProductType}
                    productTypeExists={productTypeExists}
                    ensureProductTypeInDb={ensureProductTypeInDb}
                    setRpTypeOpts={setRpTypeOpts as any}
                    onCreated={(option: any) => {
                      setForm((p: any) => ({ ...p, productType: option.label, productTypeId: option.id }));
                      setShowNewProductTypeInput(false);
                      setNewProductType("");
                      setRpTypesPrimed(false);
                    }}
                    setRpTypesPrimed={setRpTypesPrimed}
                  />
                </div>
              )}
            </div>
          </label>

            {/* Artikelnummer – 1 kol (så vi får 6 fält på raden) */}
            <label className="gw-form-field gw-col-1">
              <div className="gw-form-label">Artikelnummer hos Convit</div>
              <div className="flex flex-wrap items-center gap-2">
                <select
                  value={form.articleNumber ?? ""}
                  disabled={!form.customer}
                  onChange={(e) => {
                    const v = e.target.value;
                    if (v === "new") {
                      setShowNewArticleInput(true);
                      setForm((p: any) => ({ ...p, articleNumber: "" }));
                    } else {
                      setShowNewArticleInput(false);
                      setForm((p: any) => ({ ...p, articleNumber: v }));
                    }
                  }}
                  className="gw-input w-full max-w-full"
                >
                  <option value="">{form.customer ? "Artikelnummer" : "Välj kund först"}</option>
                  {(Array.isArray(articleList) ? articleList : []).map((a: any) => (
                    <option key={a} value={a}>{a}</option>
                  ))}
                  {form.customer && <option value="new">Lägg till ny artikel</option>}
                </select>

                {showNewArticleInput && (
                  <>
                    <input
                      type="text"
                      placeholder="Ny artikel"
                      value={newArticle}
                      onChange={(e) => setNewArticle(e.target.value)}
                      className="gw-input"
                    />
                    <button type="button" onClick={handleNewArticleAdd} className="gw-btn gw-btn-secondary" disabled={!newArticle.trim()}>
                      Lägg till
                    </button>
                  </>
                )}
              </div>
            </label>


            {/* RAD 2 — Adapter (1), Produkttyp (1), Garantistart + Garantikoll (2) */}

            <label className="gw-form-field gw-col-1">
              <div className="gw-form-label">Adapter</div>
              <select
                name="adapterYesNo"
                value={form.adapterYesNo}
                onChange={(e) => {
                  const v = e.target.value as "Yes" | "No" | "";
                  setForm((p: any) => ({ ...p, adapterYesNo: v, chargerIncluded: v === "Yes" }));
                }}
                className="gw-input"
              >
                <option value="">Välj</option>
                <option value="Yes">Ja</option>
                <option value="No">Nej</option>
              </select>
            </label>



            {/* RAD 2 — Garantiknappar (2 kol) */}
            <label className="gw-form-field gw-col-2">
              <div className="gw-form-label">Garantiåtgärd</div>
              {(() => {
                const manufacturer = (form.manufacturer || "").trim();
                const serialBase = normalizeSerialKey(splitSerialParts(form.serial || "").base);
                const ready = !!manufacturer && !!serialBase;

                return (
                  <div className="flex gap-2 w-full">
                    <button
                      type="button"
                      className="gw-btn gw-btn-primary whitespace-nowrap flex-1 min-w-0 py-[10px]"
                      onClick={() => openWarranty({
                        manufacturer,
                        serialBase,
                        form,
                        focusAfter: true,
                      })}
                      disabled={!ready}
                      title={
                        !manufacturer ? "Välj tillverkare"
                          : !serialBase ? "Fyll i serienummer"
                            : `Öppna garantisida & kopiera ${serialBase}`
                      }
                    >
                      Garantikoll
                    </button>

                    <button
                      type="button"
                      className="gw-btn gw-btn-secondary whitespace-nowrap flex-1 min-w-0 py-[10px]"
                      onClick={() => markNoWarranty(true)}
                      title='Sätt "Ingen garanti" (9999-99-99)'
                    >
                      Ingen garanti
                    </button>
                  </div>
                );
              })()}
            </label>

            {/* Garantistart – 2 kol (endast input) */}
            <label className="gw-form-field gw-col-2">
              <div className="gw-form-label">Garantistart</div>
              <input
                name="warrantyStartDate"
                type="text"
                inputMode="numeric"
                placeholder="YYYY-MM-DD"
                value={form.warrantyStartDate ?? ""}
                onInput={handleIsoDateInput}
                onChange={() => { /* mask sköter state */ }}
                onPaste={(e) => {
                  const text = e.clipboardData?.getData("text") || "";
                  const iso = parseLooseDateToISO(text);
                  if (iso) {
                    e.preventDefault();
                    setForm((p: any) => ({ ...p, warrantyStartDate: iso }));
                  }
                }}
                className="gw-input"
              />
            </label>



          {/* RAD 3 — Skador (2) + Bilder (4) */}
          <label className="gw-form-field gw-col-2">
            <div className="gw-form-label">Skador</div>
            <textarea
              name="damageNotes"
              placeholder="Eventuella skador"
              value={form.damageNotes}
              onChange={handleInputChange}
              className="gw-input"
              rows={5}
            />
          </label>

          <label className="gw-form-field gw-col-4">
            <div className="gw-form-label">Bilder</div>
            <div className="gw-photo-grid gw-photo-grid--auto">
              {(["keyboard", "screen", "underside", "topside"] as PhotoKey[]).map((type) => {
                const src = thumbnailPreviews[type];
                const label = type === "keyboard" ? "Tangentbord" : type === "screen" ? "Skärm" : type === "underside" ? "Undersida" : "Ovansida";
                return (
                  <div key={type} className="gw-photo-card">
                    <input id={`quick-photo-${type}`} type="file" accept="image/*" capture="environment" style={{ display: "none" }} onChange={(e) => handlePhotoChange(e, type)} />
                    <div role="button" tabIndex={0} onClick={() => document.getElementById(`quick-photo-${type}`)?.click()} onKeyDown={(e) => { if (e.key === "Enter") document.getElementById(`quick-photo-${type}`)?.click(); }}>
                      {src ? <img className="gw-photo-img" src={src} alt={`${label} preview`} /> : <div className="gw-photo-placeholder">Klicka för att lägga till<br />{label.toLowerCase()}</div>}
                    </div>
                    {src && (<button type="button" className="gw-photo-remove" onClick={() => handleRemovePhoto(type)} title={`Ta bort ${label}`} aria-label={`Ta bort ${label}`}>×</button>)}
                    <div className="gw-photo-title">{label}</div>
                  </div>
                );
              })}
            </div>
          </label>
        
        </div>

        <QuickActions form={form} isSaving={isSaving} handleSave={handleSave} />
      </div>
    </>
  );
}
